import { proxy, subscribe } from 'valtio';

import { ComponentSearchData } from 'models';
import { deepClone } from 'helpers/deep-clone';

import { SearchService } from 'components/component-overview/services/SearchService';

export const DEFAULT_COMPONENT_SEARCH_DATA = {
    hasSearched: false,
    docs: [],
    page: 0,
    totalPages: 1,
    totalComponents: 0,
    isLoading: false,
    error: false,
    facets: undefined,
    suggestions: undefined,
    request: undefined,
    exact: true,
    makers: undefined,
};

const componentSearchData = proxy<ComponentSearchData>(deepClone(DEFAULT_COMPONENT_SEARCH_DATA));

subscribe(componentSearchData, (changes) => {
    changes.forEach((change) => {
        const [type, path] = change;

        if (type === 'set' && path.join('.') === 'page') {
            SearchService.debouncedSearch();
        }
    });
});

export { componentSearchData };
